type TiptapNode = {
    type?: string;
    text?: string;
    content?: TiptapNode[];
};

export function extractTextFromTipTap(node: unknown): string {
    if (!node || typeof node !== "object") return "";
    const n = node as TiptapNode;
    if (n.type === "text") return n.text ?? "";
    if (Array.isArray(n.content)) {
        const joinString = n.type === "paragraph" ? "\n\n" : " ";
        return n.content.map(extractTextFromTipTap).join(joinString).trim();
    }
    return "";
}

export function countWordsFromTipTap(node: unknown): number {
    const text = extractTextFromTipTap(node).trim();
    return text.length === 0 ? 0 : text.split(/\s+/u).length;
}

export function plainTextToTiptapJson(text: string): Record<string, unknown> {
    const paragraphs = text
        .split(/\n{2,}/)
        .map((p) => p.trim())
        .filter((p) => p.length > 0);

    if (paragraphs.length === 0) {
        return { type: "doc", content: [{ type: "paragraph" }] };
    }

    return {
        type: "doc",
        content: paragraphs.map((p) => ({
            type: "paragraph",
            content: [{ type: "text", text: p }],
        })),
    };
}
